import {
  CALCULATED_OTT_EVENT_NAMES,
  COMMERCE_EVENT_NAMES_WITH_LOCAL_CURRENCY,
  CONTENT_EVENT_NAMES,
  CORE_EVENT_NAMES,
  USER_LIFECYCLE_EVENT_NAMES,
} from '../../../../common/support/eo_mapping';
import { CHARTS_DEFAULT_HIGH_CHART_CONFIG } from '../../../constants/analytics/charts';

const { INSTALL, IMPRESSION, REINSTALL, WEB_SESSION_START, CLICK, OPEN } = CORE_EVENT_NAMES;
const { revenue, ...REST_COMMERCE_EVENTS } = COMMERCE_EVENT_NAMES_WITH_LOCAL_CURRENCY;

export const OTT_ANALYTICS_EVENT_LIST = Object.keys({
  INSTALL,
  IMPRESSION,
  revenue,
  ...CALCULATED_OTT_EVENT_NAMES,
  REINSTALL,
  WEB_SESSION_START,
  CLICK,
  OPEN,

  ...USER_LIFECYCLE_EVENT_NAMES,
  ...CONTENT_EVENT_NAMES,
  ...REST_COMMERCE_EVENTS,
});

export const OTT_TRENDS_INITIAL_DATA_SOURCES = [CORE_EVENT_NAMES.INSTALL];

export const OTT_TRENDS_HIGH_CHART_CONFIG = {
  ...CHARTS_DEFAULT_HIGH_CHART_CONFIG,
  exporting: {
    filename: 'ott_analytics',
    chartOptions: {
      title: {
        text: 'OTT Analytics',
      },
    },
  },
};
